/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useLocation } from "@remix-run/react";
import HeroImage from "~/assets/images/img-hero-start.png";
import curvbackground from "~/assets/images/start-page-wave.svg";
import dotsBackground from "~/assets/images/inkusion/bg-dot-pattern-lightgray.png";
import { LandingPageTabs } from "./landing_page_tabs";

import { classNames } from "../utils";
import { ThemenBox } from "../components";
import { themenCards } from "~/constants/themen_cards";

interface IPageIntro {
  logo: boolean;
  title: string;
  subtitle?: string;
  searchBox?: React.ReactElement;
  mainImage?: any;
  size: string;
  isLandingPage?: boolean;
  activeTab?: "medien" | "fachartikel" | "veranstaltungen";
  setActiveTab?: (tab: "medien" | "fachartikel" | "veranstaltungen") => void;
}
const PageIntro: React.FC<IPageIntro> = ({
  logo,
  title,
  subtitle,
  searchBox,
  mainImage,
  size,
  isLandingPage = false,
  activeTab = "medien",
  setActiveTab,
}) => {
  const location = useLocation();

  const getHeightBasedOnScreenType = () => {
    if (isLandingPage) {
      return "";
    }

    if (
      location.pathname.includes("/method_glossar") ||
      location.pathname.includes("/impressum") ||
      location.pathname.includes("/datenschutz") ||
      location.pathname.includes("/partners")
    ) {
      return "h-hero-sm";
    }

    return "h-hero-xs";
  };

  return (
    <div
      className={classNames(
        "relative flex w-full bg-cover bg-bottom pt-0",
        getHeightBasedOnScreenType(),
        isLandingPage
          ? "min-h-[815px] md:min-h-[875px] lg:min-h-[890px] xl:min-h-[930px] 2xl:min-h-[1040px]"
          : ""
      )}
      style={{
        backgroundImage: `linear-gradient(to right, #153d71, #005283, #006792, #007c9e, #1f91a7)`,
      }}
    >
      <div
        className="flex w-full"
        style={
          isLandingPage
            ? {
                backgroundImage: `url(${dotsBackground})`,
                backgroundSize: "43%",
                backgroundPosition: "right",
                backgroundRepeat: "no-repeat",
              }
            : undefined
        }
      >
        <div
          className="z-10 flex w-full flex-col items-center"
          style={{
            backgroundImage: `url(${curvbackground})`,
            backgroundSize: "100%",
            backgroundPosition: "100% 100%",
            backgroundRepeat: "no-repeat",
            zIndex: 10,
          }}
        >
          <div className="intro-page-wrapper mx-2 flex w-full flex-col md:flex-row">
            <div
              className={classNames(
                (!subtitle && !searchBox) ||
                  location.pathname.includes("/help_center")
                  ? "justify-center "
                  : "justify-start",
                "md:1/2 flex w-full flex-col items-center md:items-start"
              )}
            >
              <div
                className={classNames(
                  isLandingPage ? "mt-6 md:mt-20 lg:mt-24" : "mt-8",
                  "pt-4 md:pt-8 md:pb-3"
                )}
              >
                <h1
                  className={classNames(
                    "text-left text-2xl font-bold leading-8 text-white md:text-3xl lg:text-[42px]"
                  )}
                >
                  {title}
                </h1>
              </div>
              {subtitle && (
                <div>
                  <p className="max-w-full py-1 pt-2 text-left text-base text-white md:max-w-lg md:pb-5 md:text-lg">
                    {subtitle}
                  </p>
                </div>
              )}
              {/* {isLandingPage && (
                <span className="mr-2 hidden text-center md:block">
                  <Link
                    to="search/main"
                    // type="Link"
                    className={classNames(
                      base,
                      "rounded-none border-b border-b-white text-sm text-white hover:border-b-btnColor-primary"
                    )}
                  >
                    Alle Medien entdecken
                    <ArrowRightIcon
                      className="ml-2 h-6 w-6 text-white hover:text-btnColor-primary"
                      aria-hidden="true"
                    />
                  </Link>
                </span>
              )} */}
            </div>
            {/* MOBILE FILTER START PAGE */}
            <div className="mt-5 flex w-full flex-col md:hidden">
              {searchBox && (
                <div className="z-50 flex w-full flex-col">
                  {isLandingPage && setActiveTab && (
                    <LandingPageTabs
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                      isMobile={true}
                    />
                  )}
                  <div
                    style={{
                      borderBottomRightRadius: "20px",
                      borderBottomLeftRadius: "20px",
                    }}
                    className="flex w-full items-center bg-white px-2 shadow-card"
                  >
                    {searchBox}
                  </div>
                  {isLandingPage && (
                    <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:gap-4">
                      {themenCards.map((card, index) => (
                        <div key={`${card.title}-${index}`} className="flex-1">
                          <ThemenBox
                            title={card.title}
                            to={card.to}
                            description={card.description}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
              <div className="flex">
                <img
                  className={classNames(
                    "h-[20rem] w-full object-contain md:object-scale-down",
                    isLandingPage ? "-mt-10" : ""
                  )}
                  src={mainImage || HeroImage}
                />
              </div>
            </div>
            {/* END MOBILE FILTER START PAGE */}
            <div className="relative  hidden w-full md:flex md:flex-col">
              <img
                className={classNames(
                  isLandingPage
                    ? "h-76 md:h-auto lg:h-[490px] xl:h-[500px]"
                    : "h-64 md:h-full",
                  "w-full object-contain md:object-scale-down"
                )}
                src={mainImage || HeroImage}
              />
              {/* {logo && (
                <div className="absolute bottom-32 right-24 hidden md:block">
                  <img src={Logo2} className="h-auto w-32 object-contain" />
                </div>
              )} */}
            </div>
          </div>

          <div className="md:-mt-18 z-10 hidden w-full md:block lg:-mt-20 xl:-mt-20">
            {searchBox && (
              <div className="intro-page-wrapper">
                {/* Tabs on top of search */}
                {isLandingPage && setActiveTab && (
                  <LandingPageTabs
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    isMobile={false}
                  />
                )}

                {/* Search bar below tabs - integrated seamlessly */}
                <div
                  style={{
                    borderTopRightRadius: "20px",
                    borderBottomRightRadius: "20px",
                    borderBottomLeftRadius: "20px",
                  }}
                  className="bg-white px-5 py-2 shadow-card"
                >
                  {searchBox}
                </div>
                {isLandingPage && (
                  <div className="mx-auto mt-8 mb-4 flex w-full  flex-col gap-3 md:flex-row md:gap-4">
                    {themenCards.map((card, index) => (
                      <div key={`${card.title}-${index}`} className="flex-1">
                        <ThemenBox
                          title={card.title}
                          to={card.to}
                          description={card.description}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageIntro;
// Type: Linear
// Angle: 90˚
// Opacity: 100%

// Color Stop 1
// Color: RGB(21, 61, 113)
// Position: 0%

// Color Stop 2
// Color: RGB(31, 145, 167)
// Position: 100%
// Type: Linear
// Angle: 90˚
// Opacity: 100%

// Color Stop 1
// Color: #153D71
// Position: 0%

// Color Stop 2
// Color: #1F91A7
// Position: 100%
